//- Navigation
let mainNav = $('.main_nav--container')[0];
let praTabs = $(mainNav).find('.par-tab');

// Prevent Default On click
praTabs.each(function () {
  this.onclick = function (e) {
    e.preventDefault();
  };
});

// Show Sub-Tabs
$('.nav-sub-menu li, .nav_pri--l li, .dropdown-content li').on('mouseover', function () {
  $(this).siblings().addClass('hovered');
}).on('mouseout', function () {
  $(this).siblings().removeClass('hovered');
});

let navbarHeight = $('.main_nav--container').outerHeight();

function hasScrolled() {
  let st = $(document).scrollTop();

  // If they scrolled down and are past the navbar.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > navbarHeight) {
    // Scroll Down
    $('.main_nav--container').addClass('nav-down');
    $('body').addClass('nav-down-padding');
  } else {
    $('.main_nav--container').removeClass('nav-down');
    $('body').removeClass('nav-down-padding');
  }

}

$('.open-nav').click(function () {
  $('.main_nav--container').addClass('nav-mobile-open');
  $('.main_navigation').slideDown();
  $(this).hide();
  $('.close-nav').show();
  $('body').css('overflow', 'hidden');
});

$('.close-nav').click(function () {
  $('.main_navigation').slideUp();
  $('.main_nav--container').removeClass('nav-mobile-open');
  $(this).hide();
  $('.open-nav').show();
  $('body').css('overflow', 'auto');
});
/*
$('.nav_pri--has-subtabs').find('a').click(function () {
  if ($(window).outerWidth() < 808) {
  $(this).toggleClass('open');
  $(this).next().stop().slideToggle();
  }
});*/

let viewPortChanged = true;

function updateNav() {
  if ($(window).outerWidth() < 808) {
    $('.main_nav--container').removeClass('nav-down');
    $('.mobile_nav--btn').show();
    $('body').removeClass('nav-down-padding');
    $('body').addClass('fixed-nav-padding');

    if (viewPortChanged) {
      $('.main_navigation').hide();
      $('.nav-sub-menu').hide();
      $('.nav_pri--has-subtabs a').removeClass('open');
    }
    viewPortChanged = false;
  }
  else {
    viewPortChanged = true;
    $('.main_navigation').show();
    $('.main_nav--container').removeClass('nav-mobile-open');
    $('.close-nav').hide();
    $('.open-nav').show();
    $('.nav-sub-menu').show();
    $('.mobile_nav--btn').hide();
    $('body').css('overflow', 'auto');
    $('body').removeClass('fixed-nav-padding');

    $(window).scroll(function (event) {
      hasScrolled();
    });
  }
}

updateNav();

// When resize
window.addEventListener('resize', function () {
  updateNav();
});

 
$('ul .has-submenu>a').on('click', function (e) {
    e.preventDefault();
    if ($(window).outerWidth() < 808) {
        $(this).toggleClass('open');
        $(this).parent().children('ul').stop().slideToggle();
    }
});